import type { StatsSnapshot } from './gameplay-snapshot';
import { sumAll } from '@game-libs/exc-libs/src/helpers/array.helpers';
import { unitStats as stats } from './index';

export const updateBardStats = (state: StatsSnapshot) => {
  const upgrades = state.upgrades.bard;
  const bard = state.generators.bard;

  // Base generation per bard (0.01 per tick from generator)
  // Plus upgrade bonus (0.001 per tick per level purchased)
  const baseGenerationPerBard = bard.baseGeneration; // 0.01
  const upgradeBonus = upgrades.tuningFork.multiplier;
  const generationPerBard = baseGenerationPerBard + upgradeBonus;

  const generatedInspiration = bard.owned * generationPerBard;

  const inspirationGeneration = sumAll([generatedInspiration]);

  stats.bard = {
    mainIndividualGenerationStat: generationPerBard,
    inspirationGeneration,
  };
};
